import type React from "react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type ServicePortalProps = {
  portalId?: string;
  children: React.ReactNode;
};

const ServicePortal = ({ portalId, children }: ServicePortalProps) => {
  const [el, setEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!portalId || typeof document === "undefined") {
      setEl(null);
      return;
    }

    const getTarget = () =>
      document.getElementById(portalId) as HTMLElement | null;

    setEl(getTarget());

    const observer = new MutationObserver(() => {
      setEl(getTarget());
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [portalId]);

  // Avoid inline fallback render to prevent top-left flash before target mounts.
  if (!el) return null;
  return createPortal(children, el);
};

export default ServicePortal;
